export default "__VITE_ASSET__CoR94oWy__"